import * as _ from 'lodash'

/*
 * 기존에 만들어져 있던 utils.ts 는 모든 종류의 프론트에서 사용할 수 없어
 * 공용으로 사용하기 위한 global-utils.ts 생성.
 * 어드민, v2 인게임 등등 프론트에서 공통으로 사용할 유틸리티 함수는 여기에 정의하여 재사용 한다.
 */

/**
 * 이미지의 용량이 커짐에 따라 데이터 소모량이 많아지는 것을 방지하기 위해
 * 작은 이미지로 저장된 URL 을 만들어 반환한다.
 *
 * 작은 이미지가 만들어지는 대상은 유저가 업로드 하는 모든 이미지에 해당하며
 *
 * 작은 이미지는 v2-web-api 서버에서 생성하여 s3 에 업로드 한다.
 *
 * https://d1i7hydgfclv7m.cloudfront.net/data_center/user_profile/cc26444e-a91b-42c0-899d-2203035fb268.webp
 *
 * 위와 같은 URL 에서 small 을 추가하여
 *
 * https://d1i7hydgfclv7m.cloudfront.net/data_center/user_profile/small/cc26444e-a91b-42c0-899d-2203035fb268.webp
 *
 * @param sourceAvatar
 */
export function makeSmallImgUrl(sourceAvatar?: string): string {
  const avatarArr = _.split(sourceAvatar, '/')
  if (_.isEmpty(avatarArr) || !_.startsWith(sourceAvatar, 'http')) return sourceAvatar

  avatarArr.splice(avatarArr.length - 1, 0, 'small')
  return avatarArr.join('/')
}
